import { render, staticRenderFns } from "./CreateDependentList.vue?vue&type=template&id=4edbc871&scoped=true"
import script from "./CreateDependentList.vue?vue&type=script&lang=js"
export * from "./CreateDependentList.vue?vue&type=script&lang=js"
import style0 from "./CreateDependentList.vue?vue&type=style&index=0&id=4edbc871&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edbc871",
  null
  
)

export default component.exports